/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const GraphHistogramIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Graph Histogram',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M33.5 30h-3a.5.5 0 0 0-.5.5v-4a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v-6a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v-8a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5V6.519A.519.519 0 0 0 17.481 6h-2.962a.519.519 0 0 0-.519.519V10.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v10a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v8a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5V34h32v-3.5a.5.5 0 0 0-.5-.5Z"
    />
  </svg>`;
};
